/**
 * The contact list's filter state, shared by the drawer that edits it, the
 * header that owns it, and the hook that queries with it.
 *
 * Its own module so the drawer file exports only a component — a value export
 * beside one breaks fast refresh.
 */

import type { ContactAdvancedFilter } from '../../../types/contactFilter.types';

export type FilterState = {
  selectedTags: string[];
  /** When true, return only contacts that have ALL `selectedTags`
   *  (AND). When false (default), match ANY tag (OR). Backend already
   *  supports the `matchAllTags` parameter — see `useContacts.ts`. */
  matchAllTags?: boolean;
  dateRange: { startDate: Date | null; endDate: Date | null };
  outcome: string[];
  leadSource: string[];
  teamMember?: string;
  leadIntent?: string[];
  has_ealerts_registered?: boolean | null;
  flywheelOptOut?: boolean | null;
  aiPaused?: boolean | null;
  flowIds?: string[];
  flowTypes?: string[];
  /** Per-channel consent (SPEC-2117). The UI only offers 'opted_in'; the API
   *  also accepts 'opted_out' and 'unknown'. Null means "don't filter this
   *  channel". Resolved server-side against the same precedence the contact's
   *  consent icons use, so the filter and the column always agree. */
  voiceConsent?: string | null;
  smsConsent?: string | null;
  emailConsent?: string | null;
  /** Field/operator/value conditions grouped with AND, OR, and NOT. Compiled
   *  and evaluated by the GraphQL resolver — see `contactFilterFields` for the
   *  fields it may reference. */
  advancedFilter?: ContactAdvancedFilter | null;
};

/** Every filter cleared — exported so callers can reset without rebuilding it. */
export const EMPTY_FILTER_STATE: FilterState = {
  selectedTags: [],
  matchAllTags: false,
  dateRange: { startDate: null, endDate: null },
  outcome: [],
  leadSource: [],
  teamMember: undefined,
  leadIntent: [],
  has_ealerts_registered: null,
  flywheelOptOut: null,
  aiPaused: null,
  flowIds: [],
  flowTypes: [],
  voiceConsent: null,
  smsConsent: null,
  emailConsent: null,
  advancedFilter: null,
};
